module.exports = __webpack_public_path__ + "static/img/like.a792fe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/like.png
// module id = tZ1D
// module chunks = 36